module.exports = __webpack_public_path__ + "img/07cf5bc5a2bdf35d286353b78a2b548e.svg";